export default __webpack_public_path__ + "static/media/attachment-1.d0b06d46.svg";